module.exports = __webpack_public_path__ + "static/media/question_darkgrey.1dcfdf5b.png";